/**
 * Brand logo for Acqua Vicina.
 * Stylized water drop with a small "proximity" arc, evoking
 * the "vicina" (nearby) concept. Pure SVG, color-themable.
 */
export const Logo = ({ size = 36, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 64 64"
    className={className}
    role="img"
    aria-label="Acqua Vicina"
    data-testid="brand-logo"
  >
    <defs>
      <linearGradient id="av-drop" x1="32" y1="6" x2="32" y2="58" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#38BDF8" />
        <stop offset="100%" stopColor="#0284C7" />
      </linearGradient>
    </defs>

    {/* Proximity arc: subtle ring around the drop */}
    <path
      d="M 12 28 A 22 22 0 0 0 52 28"
      fill="none"
      stroke="#0EA5E9"
      strokeOpacity="0.35"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <circle cx="12" cy="28" r="2.5" fill="#0EA5E9" />

    {/* Water drop */}
    <path
      d="M32 10 C 32 10, 16 28, 16 40 C 16 49.94, 23.16 56, 32 56 C 40.84 56, 48 49.94, 48 40 C 48 28, 32 10, 32 10 Z"
      fill="url(#av-drop)"
    />

    {/* Inner highlight */}
    <ellipse cx="26" cy="36" rx="3" ry="6" fill="#FFFFFF" opacity="0.55" />
  </svg>
);
